<template>
  <div>
    <Head :title="purchasereq.code" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/purchases">
        PR
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ purchasereq.code }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.project_id"
            :error="form.errors.project_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Project"
            :disabled="disabledInput">
            <option
              v-for="project in projects"
              :key="project.id"
              :value="project.id">
              {{ project.title }}
            </option>
          </select-input>
          <select-input
            v-model="form.project_activity_id"
            :error="form.errors.project_activity_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Project Activity"
            :disabled="disabledInput">
            <option
              v-for="projectactivity in projectactivities"
              :key="projectactivity.id"
              :value="projectactivity.id">
              {{ projectactivity.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.pr_location"
            :error="form.errors.pr_location"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="PR Location"
            :readonly="disabledInput" />
          <select-input
            v-model="form.pr_allocation"
            :error="form.errors.pr_allocation"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="PR Allocation"
            :disabled="disabledInput">
            <option value="PRG" selected>
              PROGRAM
            </option>
            <option value="OPR">
              OPERASIONAL
            </option>
          </select-input>
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pr-6 w-full md:w-1/2"
            label="Description"
            :readonly="disabledInput" />
        </div>
        <div class="my-8 p-8 bg-gray-50 border-b border-t border-gray-200" v-if="form.pr_allocation === 'PRG'">
          <p class="mb-4 w-full font-bold">
            Inputan Terkait Assessment
          </p>
          <div class="flex flex-wrap -mx-3">
            <div class="mb-6 px-3 w-full md:w-full">
              <label class="form-label">Buat Paket?</label>
              <div class="flex items-center">
                <input
                  id="is_create_package_yes"
                  v-model="form.is_create_package"
                  type="radio"
                  :value="true"
                  class="form-radio"
                  :disabled="disabledInput">
                <label for="is_create_package_yes" class="ml-2">YA</label>
                <input
                  id="is_create_package_no"
                  v-model="form.is_create_package"
                  type="radio"
                  :value="false"
                  class="form-radio ml-4"
                  :disabled="disabledInput">
                <label for="is_create_package_no" class="ml-2">TIDAK</label>
              </div>
            </div>
            <text-input
              v-model="form.assessment_package_code"
              :error="form.errors.assessment_package_code"
              class="px-3 w-full md:w-1/3"
              label="Kode Paket"
              :disabled="disabledInput || !form.is_create_package" />
            <text-input
              v-model="form.assessment_package_name"
              :error="form.errors.assessment_package_name"
              class="px-3 w-full md:w-1/2"
              label="Nama Paket"
              :disabled="disabledInput || !form.is_create_package" />
          </div>
        </div>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            :model-value="formatDate(form.pr_created_date)"
            :error="form.errors.pr_created_date"
            input-class="bg-gray-200"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Tanggal Input PR"
            disabled />
          <text-input
            :model-value="reqUser"
            input-class="bg-gray-200"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Pemohon"
            readonly />
          <div class="w-full" />
          <template v-if="purchasereq.status === 'DRAFT'">
            <div class="flex flex-col pb-8 pr-6 w-full md:w-1/3">
              <label for="recvdate">Tanggal Terima Logistik:</label>
              <flat-pickr
                v-model="form.pr_log_recv_date"
                :error="form.errors.pr_log_recv_date"
                class="mt-2 p-3 w-full border rounded"
                name="recvdate"
                :readonly="disabledInput" />
              <div v-if="form.errors.pr_log_recv_date" class="form-error">
                {{ form.errors.pr_log_recv_date }}
              </div>
            </div>
          </template>
          <template v-else>
            <text-input
              :model-value="formatDate(form.pr_log_recv_date)"
              class="pb-8 pr-6 w-full md:w-1/3"
              label="Tanggal Terima Logistik"
              input-class="bg-gray-200"
              disabled />
          </template>
          <div class="w-1/3" v-if="purchasereq.status === 'DRAFT'">
            <div class="pt-6 text-xs">
              *) <b>[Tanggal Terima Logistik]</b> diisi jika input data PR sudah selesai dan siap dilanjutkan dari Draft menjadi Approved
            </div>
          </div>
          <text-input
            :model-value="logUser"
            input-class="bg-gray-200"
            class="pb-8 pr-6 w-full md:w-1/3"
            label="Operator Logistik"
            readonly />
          <div class="w-full" />
          <select-input
            v-model="form.signature01_id"
            :error="form.errors.signature01_id"
            class="pb-8 pr-6 w-1/2 md:w-1/4"
            label="Menyetujui"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature02_id"
            :error="form.errors.signature02_id"
            class="pb-8 pr-6 w-1/2 md:w-1/4"
            label="Mengetahui"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature03_id"
            :error="form.errors.signature03_id"
            class="pb-8 pr-6 w-1/2 md:w-1/4"
            label="Diajukan"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature04_id"
            :error="form.errors.signature04_id"
            class="pb-8 pr-6 w-1/2 md:w-1/4"
            label="Direktur"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <text-input
            :model-value="purchasereq.status"
            class="pb-8 pr-6 w-full md:w-1/2"
            input-class="font-bold text-center"
            label="Status"
            disabled />
          <text-input
            :model-value="formatNumber(grandTotal)"
            class="pb-8 pr-6 w-1/2 text-right"
            input-class="text-right"
            label="Grand Total"
            disabled />
        </div>

        <div class="-mr-6 px-8 py-4 border-t border-gray-100" id="attachments">
          <h3 class="text-xl">
            List berkas pendukung:
          </h3>

          <ul
            v-for="(docfile, idx) in purchasereq.files"
            :key="idx"
            class="w-full list-disc">
            <li class="flex gap-2 items-center">
              <span>- </span>
              <a
                :href="docfile.url"
                :class="attachmentAccess.download ? 'text-indigo-500 underline' : 'text-red-600'"
                target="_blank"
                :download="docfile.file_name"
                :disable="!attachmentAccess.download"> {{ docfile.file_name }}</a> ( {{ docfile.size }} )
              <a
                href=""
                title="Delete attachment file"
                @click.prevent="destroyAttachment(docfile.uuid)">
                <Icon icon="ic:baseline-delete-forever" class="w-6 h-6 text-red-600" />
              </a>
            </li>
          </ul>

          <file-input
            v-model="form.attachment"
            :error="form.errors.attachment"
            class="pr-6 py-4 w-full md:w-2/3"
            type="file"
            accept="image/*, application/pdf"
            label="Browse dan upload file dokumen pendukung (Max 10MB)"
            @update:model-value="uploadAttachment"
            v-if="attachmentAccess.upload" />
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <template v-if="purchasereq.status === 'DRAFT'">
            <button
              class="text-red-600 hover:underline"
              tabindex="-1"
              type="button"
              @click="destroy">
              Delete Purchase Request
            </button>
            <loading-button
              :loading="form.processing"
              class="btn-indigo ml-auto"
              type="submit">
              Update Purchase Request
            </loading-button>
          </template>
          <template v-else>
            <a
              :href="`/purchases/${purchasereq.id}/print`"
              as="button"
              target="_blank"
              class="ml-auto px-6 py-3 text-white whitespace-nowrap text-sm font-bold leading-4 focus:bg-green-400 bg-green-500 hover:bg-orange-400 rounded"> Print PR (PDF) </a>
          </template>
        </div>
      </form>
    </div>
    <h2 class="mt-12 text-2xl font-bold">
      Details
    </h2>
    <detail-flash-messages />
    <div v-if="purchasereq.status == 'DRAFT'" class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Detail</span>
      </button>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <detail
          v-for="(requestDetail, idx) in purchasereqDetails"
          :key="requestDetail.id"
          :row-index="++idx"
          :editable-mode="requestDetail.editable"
          :request-detail="requestDetail"
          :errors="$page.props.errors"
          :units="units"
          :disabled="disabledInput"
          @destroy:detail="destroyDetail"
          @edit:detail="editDetail"
          @cancel="cancel('edit')"
          @save="updateDetail" />
        <detail
          v-if="createMode"
          :key="0"
          :editable-mode="createMode"
          :request-detail="editedItem"
          :units="units"
          :errors="$page.props.errors"
          @cancel="cancel('create')"
          @save="createDetail" />
        <tr v-if="purchasereqDetails.length === 0">
          <td class="px-6 py-4 border-t" colspan="5">
            No details found.
          </td>
        </tr>
      </table>
    </div>
    <div v-if="purchasereq.status == 'DRAFT' && purchasereqDetails.length >= 1" class="flex justify-between my-5">
      <button class="btn-indigo" @click="createMode = true">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Detail</span>
      </button>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import { sumBy } from 'lodash'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import { format, parse } from 'date-fns'
import Detail from '@/Pages/PurchaseReqs/DetailRow'
import DetailFlashMessages from '@/Shared/DetailFlashMessages'
import mapValues from 'lodash/mapValues'
import find from 'lodash/find'
import FileInput from '@/Shared/FileInput'
import { Icon } from '@iconify/vue'

export default {
    components: {
        Head,
        Link,
        Icon,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        FileInput,
        flatPickr,
        Detail,
        DetailFlashMessages,
    },
    layout: Layout,
    props: {
        purchasereq: Object,
        purchasereqDetails: Array,
        employees: Object,
        projects: Object,
        units: Object,
        attachmentAccess: Object,
    },
    remember: 'form',
    data () {
        return {
            reqUser: this.purchasereq.pr_request_user.toUpperCase(),
            logUser: this.purchasereq.pr_log_op_user.toUpperCase(),
            form: this.$inertia.form({
                project_id: this.purchasereq.project_id,
                project_activity_id: this.purchasereq.project_activity_id,
                code: this.purchasereq.code,
                status: this.purchasereq.status,
                pr_location: this.purchasereq.pr_location,
                pr_allocation: this.purchasereq.pr_allocation,
                pr_created_date: this.purchasereq.pr_created_date,
                pr_log_recv_date: this.purchasereq.pr_log_recv_date,
                pr_request_by_id: this.purchasereq.pr_request_by_id,
                pr_log_operator_id: this.purchasereq.pr_log_operator_id,
                description: this.purchasereq.description,
                is_create_package: this.purchasereq.is_create_package == 1,
                assessment_package_code: this.purchasereq.assessment_package_code,
                assessment_package_name: this.purchasereq.assessment_package_name,
                signature01_id: this.purchasereq.signature01_id,
                signature02_id: this.purchasereq.signature02_id,
                signature03_id: this.purchasereq.signature03_id,
                signature04_id: this.purchasereq.signature04_id,
                attachment: null,
            }),
            projectactivities: [],
            createMode: false,
            editedItem: {
                id: null,
                item_id: null,
                item_unit_id: null,
                item_qty: null,
                item_unit_price_est: null,
                item_unit_price_hist: null,
                specs: null,
                deleted_at: null,
                editable: false,
            },
            detailKeyRefresh: 0,
        }
    },
    computed: {
        grandTotal () {
            return sumBy(this.purchasereqDetails, 'subtotal')
        },
        disabledInput () {
            return this.purchasereq.status !== 'DRAFT'
        },
    },
    watch: {
        'form.project_id' (newVal) {
            this.getActivityByProject(newVal)
        },
        'form.is_create_package' (newValue) {
            if (!newValue) {
                this.form.assessment_package_code = null
                this.form.assessment_package_name = null
            }
        },
        'form.pr_allocation' (newValue, oldValue) {
            if (oldValue === 'PRG' && newValue === 'OPR') {
                this.form.is_create_package = false
                this.form.assessment_package_code = null
                this.form.assessment_package_name = null
            }
        },
    },
    mounted () {
        this.getActivityByProject(this.form.project_id)
    },
    methods: {
        update () {
            this.form.post(`/purchases/${this.purchasereq.id}`, {
                preserveScroll: true,
                onSuccess: () => this.form.reset('attachment'),
            })
        },
        destroy () {
            if (confirm('Are you sure you want to delete this purchase request?')) {
                this.$inertia.delete(`/purchases/${this.purchasereq.id}`)
            }
        },
        uploadAttachment () {
            this.form.attachment && this.update()
        },
        destroyAttachment (uuid) {
            if (confirm('Are you sure you want to delete this attachment file?')) {
                this.$inertia.delete(`/attachment/${uuid}`)
            }
        },
        restore () {
            if (confirm('Are you sure you want to restore this purchase request?')) {
                this.$inertia.put(`/purchases/${this.purchasereq.id}/restore`)
            }
        },
        getActivityByProject (projectId) {
            fetch(`/projectactivities?project=${projectId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.projectactivities = data.data
                })
        },
        formatDate (ymd) {
            return format(parse(ymd, 'yyyy-MM-dd', new Date()), 'dd-MMM-yyyy')
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        reset () {
            this.searchform = mapValues(this.searchform, () => null)
        },
        editDetail (detail) {
            let edited = find(this.purchasereqDetails, ['id', detail.id])
            edited.editable = true
        },
        destroyDetail (detailId) {
            this.$inertia.delete(`/purchasesdetails/${detailId}`)
        },
        resetEditedItem () {
            this.editedItem = {
                id: null,
                item: null,
                item_unit: null,
                item_qty: 0,
                item_unit_price_hist: 0,
                item_unit_price_est: 0,
                specs: null,
                editable: false,
            }
            this.createMode = false
        },
        cancel (action) {
            if (action === 'create') this.resetEditedItem()
            if (action === 'edit') this.$inertia.reload({ only: ['purchasereqDetails'] })
        },
        createDetail (value) {
            const formDetail = this.$inertia.form({
                purchase_req_m_id: this.purchasereq.id,
                item_id: value.item.id,
                item_unit_id: value.item_unit.id,
                item_type: value.item_type,
                item_qty: value.item_qty,
                item_unit_price_hist: value.item_unit_price_hist ?? 0.0,
                item_unit_price_est: value.item_unit_price_est,
                specs: value.specs,
            })
            formDetail.post('/purchasesdetails', {
                preserveScroll: true,
                onSuccess: () => {
                    this.resetEditedItem()
                },
                onError: () => {
                    this.editedItem = value
                    this.createMode = true
                },
            })
        },
        updateDetail (value) {
            const formDetail = this.$inertia.form({
                purchase_req_m_id: this.purchasereq.id,
                item_id: value.item.id,
                item_unit_id: value.item_unit.id,
                item_type: value.item_type,
                item_qty: value.item_qty,
                item_unit_price_hist: value.item_unit_price_hist,
                item_unit_price_est: value.item_unit_price_est,
                specs: value.specs,
            })
            formDetail.put(`/purchasesdetails/${value.id}`, {
                preserveScroll: true,
                onError: () => {
                    this.editedItem = value
                    let edited = find(this.purchasereqDetails, ['id', value.id])
                    if (edited) {
                        edited.editable = true
                    }
                },
            })
        },
    },
}
</script>
